<template>
  <v-slot v-bind="{ selectedChannel, channelColor }">
    <span
      :style="{ color: channelColor, color: 'grey', display: 'flex', gap: '8px', marginTop: '4px' }"
    >
      <em v-if="selectedChannel.icon" :class="selectedChannel.icon" /> {{ selectedChannel.text }}
    </span>
  </v-slot>
</template>

<script>
export default {
  name: 'ChannelLabel',
  props: ['channel'],
  computed: {
    selectedChannel() {
      const selectedChannel = this.$store.state.socialChannelOptions.find((channel) => {
        return channel.fullValue === this.channel
      })
      return (
        selectedChannel || {
          value: 'other',
          fullValue: 'other',
          fullValueForUse: 'other',
          text: 'Other',
          icon: ''
        }
      )
    },
    channelColor() {
      const selectedChannel = this.$store.state.socialChannelOptions.find((channel) => {
        return channel.fullValue === this.channel
      })
      switch (selectedChannel.fullValue) {
        case 'facebook':
          return '#3b5998'
        case 'line':
          return '#00c300'
        case 'instagram':
          return '#c13584'
        default:
          return 'grey'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ChannelLabel.vue